export default function sortIndividuals(individuals, policyHolderId) {
	const policyHolder = individuals?.find((individual) => individual?.id === policyHolderId)

	if (policyHolder) {
		return [policyHolder, ...individuals?.filter((individual) => individual?.id !== policyHolderId)]
	} else {
		return [...individuals]
	}
}
